/**
 * 菜谱里的 price/cost 为单人份。
 * 选出菜后：总售价/总成本 = Σ(单人份 × 人数)，预估利润率据此计算。
 */
import { calcBudget, calcEstimatedProfitRate, estimatedRateIssue, getProfitRateFloor, isPriceOverBudget } from './menuBudget'
import { getCurrentSelector, CURRENT_ALGORITHM } from '../algorithms'

function normalizeSelected(raw) {
  if (Array.isArray(raw)) {
    const dishes = raw.map((d) => {
      const qty = Number(d.qty) > 0 ? Number(d.qty) : 1
      return {
        ...d,
        qty,
        linePrice: d.linePrice != null ? Number(d.linePrice) : Number(d.price) * qty,
        lineCost: d.lineCost != null ? Number(d.lineCost) : Number(d.cost) * qty
      }
    })
    return { dishes, warnings: [], overCap: false }
  }
  const list = (raw && raw.dishes) || []
  return {
    dishes: list,
    warnings: (raw && raw.warnings) || [],
    overCap: Boolean(raw && raw.overCap)
  }
}

/**
 * @param {Array} dishes 菜品池
 * @param {{ guestCount: number, perCapita: number, profitRatePercent: number, needWei: boolean }} input
 */
export function generateMenu(dishes, input) {
  const guestCount = Number(input.guestCount)
  const perCapita = Number(input.perCapita)
  const rateRaw = input.profitRatePercent
  const minRate = getProfitRateFloor(rateRaw)
  const budget = calcBudget(guestCount, perCapita)

  const context = {
    guestCount,
    perCapita,
    needWei: Boolean(input.needWei),
    minRate,
    ...budget
  }

  try {
    const selector = getCurrentSelector()
    const picked = normalizeSelected(selector(dishes || [], context))
    const totalPrice = picked.dishes.reduce((sum, d) => sum + Number(d.linePrice), 0)
    const totalCost = picked.dishes.reduce((sum, d) => sum + Number(d.lineCost), 0)
    const estimatedProfitRate = calcEstimatedProfitRate(totalPrice, totalCost)

    if (isPriceOverBudget(totalPrice, budget.totalBudget)) {
      return {
        ok: false,
        error: '无法配出总售价不超过总预算的菜单，请调整餐标或菜品价格',
        algorithm: CURRENT_ALGORITHM,
        ...budget,
        dishes: [],
        warnings: [],
        overCap: false,
        totalPrice: 0,
        totalCost: 0,
        estimatedProfitRate: null
      }
    }

    const rateIssue = estimatedRateIssue(estimatedProfitRate, rateRaw)
    if (rateIssue) {
      return {
        ok: false,
        error: `无法配出符合利润率要求的菜单：${rateIssue}。请调整餐标、目标利润率或菜品价格`,
        algorithm: CURRENT_ALGORITHM,
        ...budget,
        dishes: [],
        warnings: [],
        overCap: false,
        totalPrice: 0,
        totalCost: 0,
        estimatedProfitRate: null
      }
    }

    return {
      ok: true,
      algorithm: CURRENT_ALGORITHM,
      ...budget,
      ...picked,
      totalPrice,
      totalCost,
      estimatedProfitRate
    }
  } catch (e) {
    return {
      ok: false,
      error: e.message || '配菜失败',
      algorithm: CURRENT_ALGORITHM,
      ...budget,
      dishes: [],
      warnings: [],
      overCap: false,
      totalPrice: 0,
      totalCost: 0,
      estimatedProfitRate: null
    }
  }
}
